import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useSubmotive2Form } from './hook';
import { Submotive2Data } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    SUBMOTIVE2,
    SUBMOTIVE2_DETAIL,
    SUBMOTIVE2_EDIT,
    SUBMOTIVE2_NEW,
} from '../../../../../routes/paths';
import { Submotive2ParamsHistorical } from '../historical';

export const Submotive2Form = () => {
    const {
        submotive2,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive2Data,
        submotive2Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive2Form();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    submotive2 && submotive2.id
                        ? 'Editar submotivo 2'
                        : 'Crear submotivo 2'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive2?.id || ''}
                        buttonCreate={{
                            show: Boolean(submotive2?.id),
                            route: SUBMOTIVE2_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE2,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SUBMOTIVE2_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE2_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive2?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <Submotive2ParamsHistorical
                        historical={submotive2Historical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <Submotive2Data
                data={submotive2}
                onChangeFormik={(formik) => setFormikSubmotive2Data(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
